import { helpers, required, requiredIf } from "@vuelidate/validators";
import validationJson from "~/static/locale/it/validation.json";
import Validator from "~/utils/validator";

export default {
  address: {
    required: helpers.withMessage(validationJson.required, required),
  },
  addressCity: {
    required: helpers.withMessage(validationJson.required, required),
  },
  addressCap: {
    required: helpers.withMessage(validationJson.required, required),
  },
  sameAddresses: {
    required: helpers.withMessage(validationJson.required, required),
  },
  address2: {
    required: helpers.withMessage(
      validationJson.required,
      //@ts-ignore
      requiredIf(function (value: string, { sameAddresses }: any) {
        return sameAddresses.value !== null && !sameAddresses.value;
      }),
    ),
  },
  addressCap2: {
    required: helpers.withMessage(
      validationJson.required,
      //@ts-ignore
      requiredIf(function (value: string, { sameAddresses }: any) {
        return sameAddresses.value !== null && !sameAddresses.value;
      }),
    ),
  },
  addressCity2: {
    required: helpers.withMessage(
      validationJson.required,
      //@ts-ignore
      requiredIf(function (value: string, { sameAddresses }: any) {
        return sameAddresses.value !== null && !sameAddresses.value;
      }),
    ),
  },
  iban: {
    required: helpers.withMessage(
      validationJson.required,
      //@ts-ignore
      requiredIf(function (value: string, { editIban }: any) {
        return editIban.value
      }),
    ),
    validIBAN: helpers.withMessage(
      () => validationJson.invalid_iban ?? validationJson.invalid_iban,
      (value: string, { editIban }) => {
        return editIban.value ? Validator.validIban(value) : true
      }
    ),
    notPrepaidIBAN: helpers.withMessage(
      () => validationJson.invalid_iban ?? validationJson.invalid_iban,
      (value: string, { editIban }) => {
        return editIban.value ? Validator.notPrepaidIban(value) : true
      }
    ),
  }
};
